import { BookOpen, Heart } from 'lucide-react';
import { useCopy } from '../../copy';
import { useMyCollections } from '../../hooks/useOpp';
import { GridItemSkeleton } from '../ui/Skeleton';
import { SemanticState } from '../semantic/SemanticState';

export function OppProfileCollectionsTab() {
  const { t } = useCopy();
  const { data: collections, isLoading } = useMyCollections();

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3">
        {Array.from({ length: 4 }).map((_, i) => <GridItemSkeleton key={i} />)}
      </div>
    );
  }

  if (!collections || collections.length === 0) {
    return <SemanticState illustration="empty-collection" kind="empty" title={t('discover.collections.empty')} description={t('discover.collections.emptyDesc')} />;
  }

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3">
      {collections.map((col: { id: string; opp_museum_items: { id: string; title: string; image_url?: string; like_count?: number } | null }) => {
        const item = col.opp_museum_items;
        if (!item) return null;
        return (
          <div key={col.id} className="letter-card overflow-hidden rounded-xl">
            {item.image_url ? (
              <img src={item.image_url} alt={item.title} className="h-36 w-full object-cover" />
            ) : (
              <div className="h-36 w-full bg-[hsl(var(--opp-surface-raised))] flex items-center justify-center">
                <BookOpen className="h-8 w-8 text-[hsl(var(--opp-muted))]" />
              </div>
            )}
            <div className="p-3">
              <h4 className="truncate font-serif text-sm font-bold text-[hsl(var(--opp-ink))]">{item.title}</h4>
              <div className="mt-2 flex items-center gap-1 text-xs text-[hsl(var(--opp-muted))]">
                <Heart className="h-3 w-3" /> {item.like_count ?? 0}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
